import CardBroadbandLabel from "components/Browse/CardBroadbandLabel";

interface SidegradeModel {
  productId: number;
  description: string;
  price: string;
  fullPrice: string;
  productName: string;
  isPremiumWifi: boolean;
  promotionDescription: string;
  cardName: string;
  upgradeLabel: any;
}

const SidegradesSection: React.FC<{
  sidegrade: SidegradeModel;
  removeZeroMonthsTerm: Function;
  postCustomerSummaryRequest: Function;
  getPremiumWifiImage: Function;
  isTechUpgrade: boolean;
}> = ({ sidegrade, removeZeroMonthsTerm, postCustomerSummaryRequest, isTechUpgrade }) => {
  return (
    <div key={`item.cardName-${sidegrade.description}`} className='product-card-container me-2 mb-2'>
      <div className='product-card'>
        <div className='product-details'>
          {/* {sidegrade.isPremiumWifi ? (
              <img src={getPremiumWifiImage(sidegrade.serviceOptions, sidegrade.productId)} alt='Comporium' className='product-image' />
            ) : null} */}
          <h5 className='text-center' style={sidegrade.isPremiumWifi ? { fontSize: "18px", marginTop: "15px" } : {}}>
            {sidegrade.cardName}
          </h5>
          <h6 className='product-description'>{sidegrade.description}</h6>
          <p className='promotion-description'>
            {sidegrade.price ? sidegrade.price : removeZeroMonthsTerm(sidegrade.promotionDescription)}
          </p>
        </div>
        <div className='product-footer cursor-pointer' onClick={() => postCustomerSummaryRequest("HSI", sidegrade)}>
          <span style={{ fontSize: "17px" }}>{isTechUpgrade ? "UPGRADE TO FIBER" : "SWITCH TO LOWER PRICE"}</span>
        </div>
      </div>
      {sidegrade.upgradeLabel ? <CardBroadbandLabel broadbandLabel={sidegrade.upgradeLabel} /> : null}
    </div>
  );
};

export default SidegradesSection;
